import React from "react";
import { Form, Col, Row } from "react-bootstrap";

import useValidation from "../../../../../util/useValidation";
import {
  alphaNumericWithSpecialCharacterPattern,
  yearPattern,
  fullTimeOrPartTime
} from "../../../../../constants/constants";

export const QualificationForm = ({
  qualificationTypeId,
  qualificationDetails,
  states,
  handleOnChangePersonalDetails
}) => {
  const { handleOnBlurValidation, errors } = useValidation();
  const handleOnBlurInput = e => {
    handleOnBlurValidation(e);
  };
  const isGraduate =
    qualificationTypeId === "GRADUATION" ||
    qualificationTypeId === "POSTGRADUATION"
      ? true
      : false;
  return (
    <Form.Group as={Row} controlId={qualificationTypeId}>
      <Col sm={2}>
        <Form.Label>Qualification*</Form.Label>
        <Form.Control
          size="sm"
          required
          type="text"
          name={isGraduate ? "degree" : ""}
          value={
            isGraduate
              ? qualificationDetails && qualificationDetails.degree
              : qualificationTypeId
          }
          onChange={e =>
            handleOnChangePersonalDetails(
              e,
              "qualifications",
              qualificationDetails.id
            )
          }
          onBlur={handleOnBlurInput}
          isInvalid={isGraduate ? errors.degree : ""}
          pattern={alphaNumericWithSpecialCharacterPattern}
        />
        {errors.degree && (
          <Form.Control.Feedback type="invalid">
            {errors.degree.type === "required" && "Board/Authority is required"}
            {errors.degree.type === "pattern" &&
              "Must contain only alphanumeric characters and space"}
          </Form.Control.Feedback>
        )}
      </Col>
      <Col sm={2}>
        <Form.Label>University / Board*</Form.Label>
        <Form.Control
          size="sm"
          required
          type="text"
          name={isGraduate ? "university" : "degree"}
          placeholder="University / Board"
          value={
            isGraduate
              ? qualificationDetails && qualificationDetails.university
              : qualificationDetails && qualificationDetails.degree
          }
          onChange={e =>
            handleOnChangePersonalDetails(
              e,
              "qualifications",
              qualificationDetails.id
            )
          }
          onBlur={handleOnBlurInput}
          isInvalid={isGraduate ? errors.university : errors.degree}
          pattern={alphaNumericWithSpecialCharacterPattern}
        />
        {isGraduate
          ? errors.university && (
              <Form.Control.Feedback type="invalid">
                {errors.university.type === "required" &&
                  "Board/Authority is required"}
                {errors.university.type === "pattern" &&
                  "Must contain only alphanumeric characters and space"}
              </Form.Control.Feedback>
            )
          : errors.degree && (
              <Form.Control.Feedback type="invalid">
                {errors.degree.type === "required" &&
                  "Board/Authority is required"}
                {errors.degree.type === "pattern" &&
                  "Must contain only alphanumeric characters and space"}
              </Form.Control.Feedback>
            )}
      </Col>
      <Col sm={2}>
        <Form.Label>State*</Form.Label>
        <Form.Control
          size="sm"
          required
          as="select"
          name="state"
          placeholder="State"
          value={qualificationDetails && qualificationDetails.state}
          onChange={e =>
            handleOnChangePersonalDetails(
              e,
              "qualifications",
              qualificationDetails.id
            )
          }
          onBlur={handleOnBlurInput}
          isInvalid={errors.state}
        >
          <option value="">Choose...</option>
          {states.map(state => (
            <option value={state.id}>{state.stateName}</option>
          ))}
        </Form.Control>
        {errors.state && (
          <Form.Control.Feedback type="invalid">
            {errors.state.type === "required" && "State is required"}
          </Form.Control.Feedback>
        )}
      </Col>
      <Col sm={2}>
        <Form.Label>Year of Passing*</Form.Label>
        <Form.Control
          size="sm"
          required
          type="text"
          name="completionYear"
          placeholder="Year of Passing"
          value={qualificationDetails && qualificationDetails.completionYear}
          onChange={e =>
            handleOnChangePersonalDetails(
              e,
              "qualifications",
              qualificationDetails.id
            )
          }
          onBlur={handleOnBlurInput}
          isInvalid={errors.completionYear}
          pattern={yearPattern}
        />
        {errors.completionYear && (
          <Form.Control.Feedback type="invalid">
            {errors.completionYear.type === "required" &&
              "Completed Year is required"}
            {errors.completionYear.type === "pattern" &&
              "Please enter valid Year"}
          </Form.Control.Feedback>
        )}
      </Col>
      <Col sm={2}>
        <Form.Label>% or CGPA*</Form.Label>
        <Form.Control
          size="sm"
          required
          type="text"
          placeholder="% or CGPA"
          name="grade"
          value={qualificationDetails && qualificationDetails.grade}
          onChange={e =>
            handleOnChangePersonalDetails(
              e,
              "qualifications",
              qualificationDetails.id
            )
          }
          onBlur={handleOnBlurInput}
          isInvalid={errors.grade}
          pattern={alphaNumericWithSpecialCharacterPattern}
        />
        {errors.grade && (
          <Form.Control.Feedback type="invalid">
            {errors.grade.type === "required" && "Percentage/Grade is required"}
            {errors.grade.type === "pattern" &&
              "Please enter a valid Percentage/Grade "}
          </Form.Control.Feedback>
        )}
      </Col>
      <Col sm={2}>
        <Form.Label>Full Time/Part Time*</Form.Label>
        <Form.Control
          size="sm"
          required
          as="select"
          name="isFullTimeQualification"
          value={
            qualificationDetails && qualificationDetails.isFullTimeQualification
          }
          onChange={e =>
            handleOnChangePersonalDetails(
              e,
              "qualifications",
              qualificationDetails.id
            )
          }
        >
          {fullTimeOrPartTime.map(type => (
            <option value={type.id}>{type.description}</option>
          ))}
        </Form.Control>
      </Col>
    </Form.Group>
  );
};
export default QualificationForm;
